<app-logo></app-logo>

<div class="background"></div>

<div class="error-container">
  <img src="assets/images/error.svg" alt="error" class="error-img" />
  <div class="error">Page not found</div>
</div>
